import { Link } from "react-router-dom";
import { NAV_LINKS, LOGO_IMAGE } from "@/lib/site";
import BookButton from "@/components/site/BookButton";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative z-10 border-t border-[#142142] bg-[#020617]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <Link
                            to="/"
                            data-testid="footer-logo"
                            className="inline-flex items-center gap-3 mb-6"
                        >
                            <img
                                src={LOGO_IMAGE}
                                alt="90 Day Alpha"
                                className="h-16 w-auto drop-shadow-[0_0_22px_rgba(30,144,255,0.45)]"
                            />
                        </Link>
                        <p className="text-[#a3b5d1] max-w-md leading-relaxed">
                            A 90-day transformation program for men ready to
                            build real confidence, attraction, and discipline —
                            and stop chasing the dating life they actually want.
                        </p>
                        <div className="mt-8">
                            <BookButton
                                testId="footer-book-cta"
                                label="Book Free Consultation"
                                size="lg"
                            />
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#D4AF37] mb-5">
                            Navigate
                        </h4>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.label
                                            .toLowerCase()
                                            .replace(/\s+/g, "-")}`}
                                        className="text-white/75 hover:text-[#D4AF37] transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/book"
                                    data-testid="footer-link-book"
                                    className="text-white/75 hover:text-[#D4AF37] transition-colors"
                                >
                                    Book a Consultation
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#00B7FF] mb-5">
                            The White Pill System™
                        </h4>
                        <p className="text-[#a3b5d1] leading-relaxed text-sm">
                            We don’t promise women. We promise the system —
                            Masculinity, Sexual Intelligence, Abundance Mindset,
                            Preselection — and the work to install it. Show up.
                            Do the reps. Become the man.
                        </p>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#142142] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs uppercase tracking-[0.2em] text-[#6b7c97]">
                        © {new Date().getFullYear()} 90 Day Alpha — All rights
                        reserved
                    </p>
                    <p className="text-xs uppercase tracking-[0.2em] text-[#6b7c97]">
                        Built for men who are done waiting.
                    </p>
                </div>
            </div>
        </footer>
    );
}
